import "./App.css";
import Config from "./config/Config";
function App() {
  return (
    <div className="App">
      <Config />
    </div>
  );
}

export default App;
